import React from 'react';

import { constants } from '@trqk/utils';

const { MAX_STATEMENTS_PER_USER } = constants;

/**
 * @typedef {TooManyStatementsInput}
 * @property {number} statementViewsLength current number of statements for this user
 */
interface TooManyStatementsInput {
    statementViewsLength: number;
}

/**
 * A toast shown when the user tries to upload more statements than they have available in their account.
 * @param {ToastRenderContentProps<TooManyStatementsInput>} props
 */
export const TooManyStatements = ({
    input,
}: ToastRenderContentProps<TooManyStatementsInput>): JSX.Element => {
    const statementViewsLength = input?.statementViewsLength ?? 0;
    const statementsLeft = MAX_STATEMENTS_PER_USER - statementViewsLength;
    const statementOrStatements =
        statementViewsLength > 1 ? 'statements' : 'statement';
    const statementOrStatementsLeft =
        statementsLeft > 1 ? 'statements' : 'statement';

    const advice =
        statementsLeft < 1 ? (
            <>
                <div className="mb-2">
                    You have used all your available statements.
                </div>
                <div className="font-semibold">
                    To add a new statement, delete an existing statement first.
                </div>
            </>
        ) : (
            <>
                <div className="mb-2">{`You currently have ${statementViewsLength} ${statementOrStatements} in your account.`}</div>
                <div className="font-semibold">
                    {`You can add up to ${statementsLeft} more ${statementOrStatementsLeft}.`}
                </div>
            </>
        );

    return (
        <div style={{ width: 410 }} className="px-2">
            <div className="font-bold text-highlight-orange tracking-wider mb-2">
                Warning
            </div>
            <div className="mb-2">
                {`Trqk currently supports up to ${MAX_STATEMENTS_PER_USER} statements per user.`}
            </div>
            <div className="mb-2">{advice}</div>
            <div className="mb-2">
                We are actively working to increase this size limit.
            </div>
        </div>
    );
};
